<script setup lang="ts">
import { ALIGNMENT } from '@pkg/sanity-utils/constants/alignment';
import { type PortableTextBlock } from 'sanity';
import { computed, type Component } from 'vue';

const props = defineProps<{
  block?: {
    _type: string,
    _key: string
    steps: Array<{
      _key: string,
      icon?: string,
      title: string,
      content: Array<PortableTextBlock>,
    }>,
  },
  config: {
    innerComponent?: Component
  },
}>();

const data = computed(() => ({
  type: props.block?._type,
  steps: props.block?.steps,
}));

</script>

<template>
  <component :is="props.config?.innerComponent" v-bind="data" />
</template>